import Modal from 'react-modal';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { ReportingReceiptViewModel } from '@fora-monorepo/employer-my-pages-common/types';
import { Container, desktopModalStyle, Feedback, ForaModal, LoadingPage } from '@foradevelopment/fora-ui';

import { ReportingReceiptModalContent } from './ReportingReceipt/ReportingReceiptModalContent';
import { useTypedTranslation } from '../../i18n/i18n';

type ReportModalProps = {
  closeModal: () => void;
  getReportData: () => Promise<ReportingReceiptViewModel>;
};

export const ReportModal = ({ isOpen, closeModal, ...rest }: { isOpen: boolean } & ReportModalProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { t } = useTypedTranslation();

  useEffect(() => {
    // Use SearchParams to hide main content in print mode, Probably not the best way...
    if (isOpen) {
      setSearchParams('print', { preventScrollReset: true });
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'relative';
    } else {
      document.body.style.overflow = 'auto';
      setSearchParams('', { preventScrollReset: true });
    }

    // Don't put "setSearchParams" as dependency, it will loop render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      style={{
        ...desktopModalStyle,
        content: {
          ...desktopModalStyle.content,
          width: '1240px',
          marginBottom: 0,
          transform: 'translate(-50%, 3.5rem)',
          top: '0',
        },
        overlay: { ...desktopModalStyle.overlay, overflow: 'scroll' },
      }}
      onRequestClose={closeModal}
      contentLabel={t('common.reportModalContentLabel')}
    >
      <ForaModal.Content
        hasCloseButton
        closeModal={closeModal}
        style={{ marginBottom: 0, paddingBottom: '60px', minHeight: 'calc(100vh - 6.5rem)', maxHeight: 'fit-content' }}
      >
        <ModalContent closeModal={closeModal} {...rest} />
      </ForaModal.Content>
    </Modal>
  );
};

const ModalContent = ({ getReportData }: ReportModalProps) => {
  const [data, setData] = useState<ReportingReceiptViewModel>({
    organizationName: '',
    payMonthSummaries: [],
    organizationNumber: '',
    reportDate: '',
    reporterName: '',
    source: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const { t } = useTypedTranslation();
  useEffect(() => {
    getReportData()
      .then(reportData => {
        setData(reportData);
        setLoading(false);
      })
      .catch(() => setError(t('errorMessages.generic.title')));
  }, [getReportData]);

  if (error) {
    return (
      <Feedback type="error" marginBottom={40} negativeSideMargins>
        {error}
      </Feedback>
    );
  }
  if (loading) {
    return (
      <Container minHeight={300}>
        <LoadingPage />
      </Container>
    );
  }
  return <ReportingReceiptModalContent {...data} />;
};
